// A.THINK
import React, { useRef, useContext, FC } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'

import SEOContext from 'context/SEOContext'
import useOnClickOutside from 'hooks/useClickOutside'
import useAlert from 'store/common/useAlert'

import { postAxiosSingle } from 'pages/api/axios'
import { generateSocialLinks } from './generateSocialLinks'
import { preparedIdURL } from 'utils/getURLData'
import { copyToClipboard } from 'utils/copyToClipboard'
import {
  PLACEFLAG_BANNER,
  PLACEFLAG_FUTURE,
  PLACEFLAG_PAST,
  WithoutCampaignQuery,
} from 'constants/analytic-data'
import { Pathname } from 'constants/data'
import { URL_LIST } from 'constants/url'
import { ShareType, shareItems } from './data'
import { AlertType } from 'constants/alert'
import { A_sm_clickShare } from 'utils/analytics/other/share_material/share_material'

import styles from './like-share.module.scss'

interface ILikeShareMenu {
  setClosed: () => void
  modificator?: string
}

const LikeShareMenu: FC<ILikeShareMenu> = ({ setClosed, modificator }) => {
  const SEOData = useContext(SEOContext)

  const ref = useRef(null)
  const { pathname } = useRouter()
  const { setSingleAlert } = useAlert()
  useOnClickOutside(true, ref, setClosed)

  if (pathname === `/${Pathname.MAIN}`) SEOData.PLACE = PLACEFLAG_BANNER

  const handleClick = async (e: React.SyntheticEvent<EventTarget>) => {
    const type = (e.target as HTMLLIElement).dataset.type
    if (!type) return

    A_sm_clickShare(type)

    if (type === ShareType.COPY) {
      const link =
        SEOData.PLACE !== PLACEFLAG_FUTURE
          ? SEOData?.LINK?.replace(/[?&]?origin=([A-Z]*)[&]?/i, '')
          : SEOData.LINK

      const campaignQuery =
        SEOData.PLACE && WithoutCampaignQuery.includes(SEOData.PLACE)
          ? ''
          : SEOData.PLACE === PLACEFLAG_PAST
            ? `&utm_campaign=`
            : `&utm_campaign=${SEOData.PLACE}`

      await copyToClipboard(
        `${link}${
          link?.includes('?') ? '&' : '?'
        }utm_source=medpoint&utm_medium=share${campaignQuery}` || ''
      )
      setSingleAlert({
        type: AlertType.COPY,
        id: `${AlertType.COPY}_LINK`,
        text: 'Ссылка скопирована в буфер обмена',
      })
      return setClosed()
    }
    const [_, materialType, id] = preparedIdURL(window.location.pathname).split('/')
    const data = {
      id,
      type: materialType,
    }

    await postAxiosSingle(URL_LIST.REPOST, {}, data)
    const links = generateSocialLinks(SEOData)
    window.open(links[type], '_blank')
    setClosed()
  }

  return (
    <ul
      className={clsx(styles.shareList, { [modificator as string]: modificator })}
      ref={ref}
      onClick={handleClick}
    >
      {shareItems.map((item) => (
        <li className={styles.shareItem} key={item.type} data-type={item.type}>
          <div className={styles.shareIcon}>
            <Image src={item.image} width="20" height="20" alt={item.alt} unoptimized={true} />
          </div>
          <span className={styles.shareText}>{item.text}</span>
        </li>
      ))}
    </ul>
  )
}

export default LikeShareMenu
